import React from "react";

const TestError: React.FC = () => {
  const BuggyComponent: React.FC = () => {
    throw new Error("Test error from BuggyComponent");
  };
  return (
    <div className="p-4">
      <h2 className="text-2xl font-semibold">This will throw an error:</h2>
      <BuggyComponent />
    </div>
  );
};

export default TestError;
